import { render, staticRenderFns } from "./GovavaAIGift.vue?vue&type=template&id=f56a477a&scoped=true"
import script from "./GovavaAIGift.vue?vue&type=script&lang=js"
export * from "./GovavaAIGift.vue?vue&type=script&lang=js"
import style0 from "./GovavaAIGift.vue?vue&type=style&index=0&id=f56a477a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56a477a",
  null
  
)

export default component.exports